<div class="flex flex-col gap-6" *ngIf="vm$ | async as vm">
	<ng-container
		[ngSwitch]="vm.saveTimeSection"
		*ngIf="validations$ | async as validations"
	>
		<ui-section
			*ngSwitchCase="'fundingDetails'"
			icon="clock-bolt"
			title="Save Time On Your Request For Funds"
			[collapsable]="true"
		>
			<div section-content class="flex flex-col gap-6">
				<p class="p-sm">
					Help us autofill the remaining details on your Request for Funds if
					they are applicable to your transaction in Closer. With this
					information, we can seamlessly populate lender's forms.
				</p>
				<div class="grid grid-cols-2 gap-6">
					<div
						*ngFor="
							let field of validations?.fundingDetailsValidation?.missingFields
						"
						class="p-4 rounded-lg border"
					>
						<div class="flex gap-2">
							<i-tabler name="home" class="w-4 h-4" />
							<h6 class="h6">{{ field.label }}</h6>
						</div>
						<ui-anchor>{{ field.parentField }}</ui-anchor>
					</div>
				</div>
			</div>
		</ui-section>

		<ui-section
			*ngSwitchCase="'finalReport'"
			icon="clock-bolt"
			title="Save Time On Your Final Report"
			[collapsable]="true"
		>
			<div section-content class="flex flex-col gap-6">
				<p class="p-sm">
					Help us autofill the remaining details on your Request for Funds if
					they are applicable to your transaction in Closer. With this
					information, we can seamlessly populate lender's forms.
				</p>
				<div class="grid grid-cols-2 gap-6">
					<div
						*ngFor="
							let field of validations.finalReportValidation.missingFields
						"
						class="p-4 rounded-lg border"
					>
						<div class="flex gap-2">
							<i-tabler name="home" class="w-4 h-4" />
							<h6 class="h6">{{ field.label }}</h6>
						</div>
						<ui-anchor>{{ field.parentField }}</ui-anchor>
					</div>
				</div>
			</div>
		</ui-section>
	</ng-container>

	<div
		*ngIf="vm.isMissingLenderOrCharge; else syncDocuments"
		class="w-full gap-2 rounded-lg border border-red-lighter bg-red-lightest p-5 flex flex-col justify-center"
	>
		<div class="flex items-center gap-2">
			<app-icon [icon]="ICON.EXCLAMATION" class="text-red"></app-icon>
			<p class="text-base text-grey-darkest">
				Missing Lender and/or Charge Type
			</p>
		</div>

		<div class="flex flex-col gap-4">
			<p class="text-sm text-grey">
				Please select a <span class="font-bold">Lender</span> and
				<span class="font-bold">Charge Type</span> so we can determine if we
				have the forms you're looking for!
			</p>

			<ui-anchor (click)="goto($event, DetailNavType.MORTGAGE_DETAILS)"
				>Go to Mortgage Details
			</ui-anchor>
		</div>
	</div>

	<ng-template #syncDocuments>
		<div
			*ngIf="
				vm.hasForms &&
				(fundingDetailDocumentValidation | async).isMissingRequiredField
			"
			class="w-full gap-2 rounded-lg border border-red-lighter bg-red-lightest p-5 flex flex-col justify-center"
		>
			<div class="flex items-center gap-2">
				<app-icon [icon]="ICON.EXCLAMATION" class="text-red"></app-icon>
				<p class="text-base text-grey-darkest">Missing Funding Details</p>
			</div>
			<div class="flex flex-col gap-4">
				<p class="text-sm text-grey">
					{{
						(fundingDetailDocumentValidation | async).hasFundingDetails
							? ''
							: 'Please add your Funding Details so we can auto-populate your Request for Funds form.'
					}}
					<span
						*ngIf="
							!(fundingDetailDocumentValidation | async)
								.hasLocalBranchIfRequired
						"
						class="text-sm text-grey"
					>
						This lender requires trust account and local branch information to
						complete the Request for Funds.
					</span>
				</p>

				<ui-anchor (click)="goto($event, DetailNavType.MORTGAGE_DETAILS)"
					>Go to Funding Options
				</ui-anchor>
			</div>
		</div>

		<div
			class="flex flex-col h-full rounded-xl border bg-white border-gray-200"
		>
			<div class="grid grid-cols-2 bg-gray-50 overflow-hidden rounded-t-xl">
				<ng-container *ngFor="let tab of TABS">
					<div
						(click)="selectTab(tab.value)"
						class="cursor-pointer rounded-t-xl duration-300 border-b p-4"
						[attr.data-intercom-target]="tab.intercomAttr"
						[ngClass]="{
							'shadow border-gray/0 bg-white': vm.selectedTab === tab.value,
							'border-gray-200 shadow-black/0': vm.selectedTab !== tab.value,
						}"
					>
						<ui-content-header
							type="section"
							[title]="tab.title"
							[subtitle]="tab.subtitle"
						></ui-content-header>
					</div>
				</ng-container>
			</div>
			<div class="p-4 min-h-[50vh]">
				<app-closer-sync-generate-package
					(gotoHistory)="gotoHistory()"
					[syncFlowType]="vm.syncFlowType"
					*ngIf="
						vm.selectedTab === TAB_TYPES.SEND_TO_LENDER ||
						vm.syncFlowType === SYNC_FLOW_TYPES.EMAIL
					"
				></app-closer-sync-generate-package>
				<div *ngIf="vm.selectedTab === TAB_TYPES.PACKAGES">
					<app-closer-sync-packages></app-closer-sync-packages>
				</div>
			</div>
		</div>
	</ng-template>
</div>
